import { AbstractControl, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import 'moment/locale/pt-br';
export class Helper {

  public static dateDiff(dtInit: Date, dtFinal: Date, returnType: string = 'days') {
    const diff = dtFinal.getTime() - dtInit.getTime();
    // tslint:disable-next-line:max-line-length
    if (returnType === 'seconds') { return Math.floor(diff / 1000); }
    else if (returnType === 'minutes') { return Math.floor(diff / 60000); }
    else if (returnType === 'hours') { return Math.floor(diff / 3600000); }
    else if (returnType === 'days') { return Math.floor(diff / 86400000); }
    else if (returnType === 'months') { return Math.floor(diff / 2419200000); }
    else { return new Date(diff); }
  }

  /**
   * @description Change itens to uppercase by specific field
   * @param arrayItems
   * @param field
   */
  public static changeToUpercase(arrayItems: any[], field: string): any[] {
    if (field.includes('.')) {
      const objects = field.split('.');

      arrayItems.map(x => {

        let item = x;

        objects.forEach(element => {
          item = item[element]
        });

        item = item.toUpperCase();
      });


      return arrayItems;
    } else {
      arrayItems.map(x => {
        x[field] = x[field].toUpperCase()
      });
      return arrayItems
    }
  }

  /**
   * @description Sort array by specific field
   * @param arrayItems
   * @param paramToOrder
   */
  public static sortItems(arrayItems: any[], paramToOrder: string) {

    if (paramToOrder.includes('.')) {

      const objects = paramToOrder.split('.');

      arrayItems.sort(

        function (a, b) {

          let itemA = a;
          let itemB = b;

          objects.forEach(
            (x) => {
              itemA = itemA[x];
              itemB = itemB[x];
            }
          );

          if (itemA > itemB) {
            return 1;
          }
          if (itemA < itemB) {
            return -1;
          }
          return 0;
        }
      );

    } else {

      arrayItems.sort(

        function (a, b) {

          if (a[paramToOrder] > b[paramToOrder]) {
            return 1;
          }

          if (a[paramToOrder] < b[paramToOrder]) {
            return -1;
          }

          return 0;

        }
      );
    }

    return arrayItems;
  }

  /**
 * @description Sort array
 * @param arrayItems
 */
  public static sortArray(arrayItems: any[]) {
    arrayItems.sort(function (a, b) {
      if (a > b) {
        return 1;
      }
      if (a < b) {
        return -1;
      }
      return 0;
    });
    return arrayItems;
  }

  /**
   * @description Get days of week to block calendar
   * @param date
   */
  public static daysOfWeek = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  }

  public static imageToBack(image) {
    return image.replace(/^data:image\/[a-z]+;base64,/, "");
  }

  public static imageToFront(image) {
    return 'data:image/png;base64,' + image;
  }

  public static base64StringToBlob(base64: string, contentType: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    return new Blob([new Uint8Array(byteNumbers)], { type: contentType });
  }

  public static downloadBlobFile(name, file): void {
    let url = window.URL.createObjectURL(file);
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = name;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  public static openBlobFileInNewTab(file): void {
    let url = window.URL.createObjectURL(file);
    window.open(url, '_blank');
  }

  public static capitalizeFirstLetter(name) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  /**
   *
   * @param date format(DD/MM/YYYY)
   * @param time format(hh:mm:ss)
   * @returns
   */
  public static formatDateUtc(date, time) {
    let data = date;
    if (date.indexOf('/') <= 0) {
      data = moment(date).format('DD/MM/YYYY');
    }
    const dataSplit = data.split('/');
    let mes = Number(dataSplit[1]);
    mes--;
    const dataAtual = moment(new Date(Number(dataSplit[2]), mes, Number(dataSplit[0]))).format('YYYY-MM-DD');
    const dateComplete = moment.utc(`${dataAtual} ${time}`).format();

    return dateComplete;
  }

  /**
   *
   * @param date format(DD/MM/YYYY)
   * @returns
   */
  public static formatDateISO(date) {
    return moment(date, "DD/MM/YYYY").toISOString();
  }

  /**
  *
  * @param date format(YYYY/MM/DD)
  * @returns
  */
  public static createBrDate(date) {
    const dataSplit = date.split('/');
    let mes = Number(dataSplit[1]);
    mes--;
    return new Date(Number(dataSplit[0]), mes, Number(dataSplit[2]))
  }

  /**
*
* @param date format(DD/MM/YYYY)
* @returns new Date()
*/
  public static createInternationalDate(date) {
    const dataSplit = date.split('/');
    let mes = Number(dataSplit[1]);
    mes--;
    return new Date(Number(dataSplit[2]), mes, Number(dataSplit[0]))
  }


  public static checkUrlBack(activatedRoute: ActivatedRoute) {
    return activatedRoute.snapshot.url[0].path == 'adicionar' ? '../' : '../../';
  }

  public static generateNameReport(name, filter) {
    if (filter && Object.keys(filter).length > 0) {
      Object.keys(filter).map(x => name += ` - ${x} ${filter[x]}`)
    }
    return name;
  }

  /**
   * @description Verifica se o tamanho da tela é maior que um determinado número
   * @param size Tamanho da tela - Apenas o número
   * @returns boolean
   */
  public static checkMaxWidth(size: number) {
    size.toString();
    const mediaQuery = window.matchMedia(`(max-width: ${size}px)`)
    return mediaQuery.matches;
  }

  /**
 * @description Verifica se o tamanho da tela é menor que um determinado número
 * @param size Tamanho da tela - Apenas o número
 * @returns boolean
 */
  public static checkMinWidth(size: number) {
    size.toString();
    const mediaQuery = window.matchMedia(`(min-width: ${size}px)`)
    return mediaQuery.matches;
  }
  /**
  * @description Verifica se o tamanho da tela é maior que um determinado número
  * @param size Tamanho da tela - Apenas o número
  * @returns boolean
  */
  public static checkMaxHeight(size: number) {
    size.toString();
    const mediaQuery = window.matchMedia(`(max-height: ${size}px)`)
    return mediaQuery.matches;
  }

  /**
  * @description Verifica se o tamanho da tela é menor que um determinado número
  * @param size Tamanho da tela - Apenas o número
  * @returns boolean
  */
  public static checkMinHeight(size: number) {
    size.toString();
    const mediaQuery = window.matchMedia(`(min-height: ${size}px)`)
    return mediaQuery.matches;
  }

  public static getDate(date) {
    return moment(date).format('DD/MM/YYYY')
  }

  public static getTime(date) {
    return moment(date).format('HH:mm')
  }

  /**
  * @description Adiciona o asterisco nos inputs quando ele for obrigatório
  * @param formcontrol do imput
  * @returns * (asterisco) ou '' vazio
  */
  public static checkIsRequired(fControl: UntypedFormControl) {
    const validator = fControl && fControl.validator && fControl.validator({} as AbstractControl);
    return validator && validator.required ? '*' : '';
  }

  /**
  * @description Checa se um objeto tem a propriedade oriunda do form
  * @param (objeto da nova classe, valores do formulário)
  * @returns retorna objeto apenas com os valores da classe
  */
  public static checkHasObjectPropertyes(objFinal, objToMerge) {
    Object.keys(objFinal).forEach((key) => {
      if (key in objToMerge) {
        objFinal[key] = objToMerge[key];
      }
      if (!objFinal[key]) {
        delete objFinal[key]
      }
    });
    return objFinal
  }

  /**
  * @description Remove propriedades nulas de um objeto
  * @param objeto para verificação
  * @returns retorna objeto sem as classes nulas
  */
  public static removeNullProperties(object) {
    Object.keys(object).forEach(
      (el) => {
        if (!object[el]) delete object[el]
      }
    )
    return object
  }

  /**
    * @description Converte a string de horário quando usado a diretiva [mask] no formato 0000
    * @param 0000
    * @returns 00:00
  */
  public static convertStringToHourFromMask(value) {
    return `${value.slice(0, 2)}:${value.slice(2, 4)}`
  }

  /**
    * @description converte um valor para uma unidade do jspdf
    * @param (valor, unidade)
    * @returns valor convertido para a unidade
  */
  public static convertPointsToUnit(points, unit) {
    // Unit table from https://github.com/MrRio/jsPDF/blob/ddbfc0f0250ca908f8061a72fa057116b7613e78/jspdf.js#L791
    var multiplier;
    switch (unit) {
      case 'pt': multiplier = 1; break;
      case 'mm': multiplier = 72 / 25.4; break;
      case 'cm': multiplier = 72 / 2.54; break;
      case 'in': multiplier = 72; break;
      case 'px': multiplier = 96 / 72; break;
      case 'pc': multiplier = 12; break;
      case 'em': multiplier = 12; break;
      case 'ex': multiplier = 6;
      default:
        throw ('Invalid unit: ' + unit);
    }
    return points * multiplier;
  }

  /**
  * @description Comprime uma imagem para uma nova com o novo tamanho
  * @param (src da imagem, novo tamanho eixo x, novo tamanho eixo y)
  * @returns retorna nova imagem
  */
  async compressImage(src, newX, newY): Promise<string> {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        elem.width = newX;
        elem.height = newY;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, newX, newY);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

  /**
   * @description Converte uma data para o formato inteiro
   * @param dataNascimento
   * @returns data no formato inteiro
   */
  public static formatBirthDateToInt(dataNascimento: string | Date): number {
    if (typeof dataNascimento === 'string') {
        dataNascimento = new Date(dataNascimento);
    }

    if (Object.prototype.toString.call(dataNascimento) !== '[object Date]' || isNaN(dataNascimento.getTime())) {
        throw new Error("Data inválida");
    }

    const ano = dataNascimento.getFullYear();
    const mes = String(dataNascimento.getMonth() + 1).padStart(2, '0');  
    const dia = String(dataNascimento.getDate()).padStart(2, '0');

    const dataInteiro = parseInt(ano + mes + dia, 10);
    
    return dataInteiro;
  } 

  /**
   * @description Retorna o CFC do usuário logado
   * @returns cfc
   */
  public static getCfcInfo() {
    const userLogin = localStorage.getItem('ngx-webstorage|user_auth');
    if (userLogin) {
      const parsedUserLogin = JSON.parse(userLogin);
      return parsedUserLogin.cfc;
    }
  }
}
